<template>
  <div class="px-2 py-1">
    <span class="font-medium">{{ item.vin }}</span><br/>
    <span class="font-light">{{ item.registration }}</span>
  </div>
</template>

<script>
export default {
  name: "fleet-column-identification",
  props: ['column', 'item'],
  methods: { },
}
</script>

<style scoped>

</style>